export default {
    companyById: [],
    defaultCompany: null,
    allCompanies: [],
    userCompanies: [],
    selected: [],
    loading: true
}
